import React, { useMemo, useCallback, useState } from "react";
import { useRouter } from "next/dist/client/router";
import Box from "../components/base/Box";
import PromotionIcon from "../components/icons/PromotionIcon";
import ReportIcon from "../components/icons/ReportIcon";
import AccountIcon from "../components/icons/AccountIcon";
import Tab from "../components/Tab";
import { themeVariables } from "../themes/constants";
import styled from "styled-components";

interface Props {}

const tabs = [
  {
    icon: PromotionIcon,
    name: "Ưu đãi",
    path: "/promotion",
  },
  {
    icon: ReportIcon,
    name: "Báo cáo",
    path: "/report",
  },
  {
    icon: AccountIcon,
    name: "Tài khoản",
    path: "/account",
  },
];

const excludeBounceRoutes = ["/promotion"];

const MainLayout: React.FC<Props> = (props) => {
  const { children } = props;
  const router = useRouter();

  const { pathname, replace } = router;

  console.log(pathname);

  const basePath = useMemo(() => {
    return "/" + pathname?.split("/")[1];
  }, [pathname]);

  const handleTabChange = useCallback(
    (path: string) => {
      replace(path);
    },
    [replace]
  );

  const isIOS = useMemo(() => {
    const ua = window?.navigator?.userAgent?.toLowerCase();
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(window?.navigator?.platform) ||
      !!ua?.includes("ios") ||
      ua?.includes("iphone") ||
      ua?.includes("mac")
    );
  }, []);

  return (
    <Box display="flex" flex={1} flexDirection="column" height="100%">
      <Container>
        <Box
          display="flex"
          flexDirection="column"
          flex={1}
          height={
            isIOS && !excludeBounceRoutes.includes(pathname)
              ? "calc(100% + 1px)"
              : "100%"
          }
        >
          {children}
        </Box>
      </Container>
      <Box
        borderTopColor={themeVariables.colors.border}
        borderTopWidth={1}
        borderTopStyle="solid"
      >
        <StyledBox display="flex" backgroundColor="white" fontSize={11}>
          {tabs.map((tab) => (
            <Tab
              key={tab.path}
              {...tab}
              onTabChange={handleTabChange}
              selected={basePath === tab.path}
            />
          ))}
        </StyledBox>
      </Box>
    </Box>
  );
};

const Container = styled(Box)`
  height: 100%;
  overflow-y: scroll;
  background-color: ${(props) => props.theme.colors.base};
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

const StyledBox = styled(Box)`
  padding-top: 12px;
  padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
`;

export default MainLayout;
